const header = {
  // all the properties are optional - can be left empty or deleted
  homepage: '',
  title: 'AC.',
}

const about = {
  // all the properties are optional - can be left empty or deleted
  name: 'Alvin Chim',
  role: 'Quantity Surveyor/Estimator',
  picture: '',

  descriptionPara1:
    'Results-driven Quantity Surveyor with 6 years of progressive experience in cost estimating, contract administration, commercial management, and project cost control. Proven expertise in preparing accurate cost plans and estimates, preparing tender documents and analysis ,managing variations and claims and delivering value engineering solutions across construction projects over the entire project life-cycle.',
  descriptionPara2:
    'On top of my QS/estimating expertise, I have expanded my skillsets in advanced data analytics, Power BI, and data visualisation, which enhances project cost control, forecasting and monitoring.',
  resume: '',
  social: {
    linkedin: 'https://www.linkedin.com/in/alvin-chim-5599a8145/',
  },
}

const projects = [
  // projects can be added an removed
  // if there are no projects, Projects section won't show up
  {
    name: 'High Rise Public Residential Complex at Ching Hong Road North (Hong Kon)',
    client: 'Hong Kong Housing Authourity',
    sector: 'Public - Residential',
    description:
      'Two 40-storey public residential buildings, comprising 1,500 units. Contract valued at $235 million',
    duties:
      'Prepared quantity takeoff for tender documents, evaluated interim payment and change orders, settled final account',
    image: 'hkha1.jpeg',
  },
  {
    name: 'High Rise Public Residential Complex at Anderson Road Quarry (Hong Kong)',
    client: 'Hong Kong Housing Authourity',
    sector: 'Public - Residential',
    description:
      'Two 26-storey public residential building, comprising 1,140 units. Contract valued at $175 million',
    duties:
      'Prepared quantity takeoff for tender documents, evaluated interim payment and change orders, settled final account',

    image: 'hkha2.jpg',
  },
  {
    name: 'Design and Construction: Administration Building for Water Treatment Plant (Hong Kong)',
    client: 'Hong Kong Water Service Department',
    sector: 'Public - Institutional',
    description:
      '4-storey admin building for a nearby water treatment plant, comprising administrative offices and high-end laboratories, valued at $125 million',
    duties:
      'Acted as an on-site QS on the general contractor side. Prepared quantity takeoff and tender documents for subcontracting. Managed subcontractors regarding payement and change orders. Prepared and submitted payment application to client.',

    image: 'cw.png',
  },
  {
    name: 'Replacement of Floor Tiles and False Ceiling for Olympic City 2 (Hong Kong)',
    client: 'Sino Group',
    sector: 'Private - Commercial',
    description:
      'Replacement of floor tiles and false ceiling system for a high-end shopping mall. Total construction floor area over 10000m2',
    duties:
      'Provided full life cycle cost management services, including cost planning, tender preparation and analysis, contract administration',
    image: 'oc2.jpg',
  },
  {
    name: 'Renovation Works for University Lecture Theaters',
    client: 'The Hong Kong Polytechnic University',
    sector: 'Private - Institutional',
    description:
      '',
    duties:
      'Valuation of up to 100 change orders, negotiation with the contractor and settlement of final accounts',
    image: 'polyu.jpg',
  },
  {
    name: 'Renovation Works for University Laboratories',
    client: 'The Hong Kong Polytechnic University',
    sector: 'Private - Institutional',
    description:
      '',
    duties:
      'Prepared tender docuemnts, tender analysis and report, handled interim payment applications, changed orders and final account settlement',
    image: 'polyu2.jpg',
  },
]

const skills = [
  // skills can be added or removed
  // if there are no skills, Skills section won't show up
  'Quantity Takeoff',
  'Cost Estimating',
  'Cost Planning',
  'Tender Documents Preparation',
  'Tender Analysis and Reporting',
  'Value Engineering',
  'Contract Administration',
  'Interim Payment Valuation',
  'Change Orders Valuation',
  'Final Account Settlement',
  'Project Cost Control',
  'Earned Value Management',
  'Bluebeam Revu',
  'Advanced Excel',
  'Power BI',
  'Primavera P6'
]

const contact = {
  // email is optional - if left empty Contact section won't show up
  email: 'alvin.hs.chim@gmail.com',
}

export { header, about, projects, skills, contact }
